import React from 'react'

import {
  ContentCard,
  ContentImage,
  ContentTitle,
  ContainerInfo,
  ContentInfoQuotes,
  Header,
} from '../styles'

const CardCourses = () => {
  return (
    <ContentCard>
      <Header>
        <ContentImage />
        <ContentTitle>
          <p>Formación para vocal coaches | 3° generación</p>
        </ContentTitle>
      </Header>

      <ContainerInfo>
        <ContentInfoQuotes>
          <p>
            3 <span>/18</span> Clases
          </p>
        </ContentInfoQuotes>
        <ContentInfoQuotes>
          <p>
            1 <span>/2</span> Cuotas
          </p>
        </ContentInfoQuotes>
      </ContainerInfo>
    </ContentCard>
  )
}

export default CardCourses
